import { toast } from 'src/components/common/ToastComponent/toast';
import { callGet, callPost } from '../axios'
import { useNavigate } from 'react-router-dom';
import { persistUserTimezone } from '../timezone'

const storeUserSession = (userData) => {
    if (!userData) return
    let savedTimezone = null
    try {
        savedTimezone = localStorage.getItem('userTimezone')
    } catch {
        savedTimezone = null
    }
    const mergedUserData = {
        ...userData,
        timezone: userData.timezone || savedTimezone || null,
    }
    localStorage.setItem('userData', JSON.stringify(mergedUserData))
    if (mergedUserData.timezone) {
        persistUserTimezone(mergedUserData.timezone)
    }
}

export const doResendLogin2FA = async ({ email, password, userType = 'admin' }) => {
    const bodyFormData = new FormData();
    bodyFormData.append('email', email);
    bodyFormData.append('password', password);
    bodyFormData.append('userType', userType);
    bodyFormData.append('type', 'resendLogin2FA');
    return callPost(`/authenticate.php`, bodyFormData, '', 1).then((res) => {
        return res?.data?.data;
    }).catch((err) => {
        return Promise.reject(err);
    });
};

export const doLogin = async ({ email, password, type = 'login', otp }) => {
    var bodyFormData = new FormData();
    bodyFormData.append('email', email);
    bodyFormData.append('password', password);
    bodyFormData.append('type', type);
    if (otp) {
        bodyFormData.append('otp', otp);
    }

    return callPost(`/authenticate.php`, bodyFormData, '', 1).then((res) => {
        const data = res?.data?.data;
        if (data?.is2FARequired) {
            return data;
        }
        if (data?.userData) {
            storeUserSession(data.userData);
        }
        if (data?.token) {
            localStorage.setItem('token', JSON.stringify(data.token));
        }
        return data;
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const doLogout = async (isAutoLogout = false) => {
    var token = JSON.parse(localStorage.getItem("token"));
    var bodyFormData = new FormData()
    bodyFormData.append('type', 'logout')
    bodyFormData.append('accessToken', token)
    return callPost(`/authenticate.php`, bodyFormData, token).then((res) => {
        localStorage.removeItem('userData')
        localStorage.removeItem('userTimezone')
        localStorage.removeItem('token')
        return res?.data?.data
    }).catch((err) => {
        if (isAutoLogout) {
            localStorage.removeItem('userData')
            localStorage.removeItem('userTimezone')
            localStorage.removeItem('token')
        }
        return Promise.reject(err)
    })
}

export const doForgotPassword = async ({ userName, userType }) => {
    var bodyFormData = new FormData()
    bodyFormData.append('type', 'forgot')
    bodyFormData.append('userName', userName)
    bodyFormData.append('userType', userType)
    return callPost(`/authenticate.php`, bodyFormData, '', 1).then((res) => {
        return res?.data?.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const doResetPassword = async ({ newPassword, resetToken }) => {
    var bodyFormData = new FormData()
    bodyFormData.append('type', 'reset')
    bodyFormData.append('newPassword', newPassword)
    bodyFormData.append('resetToken', resetToken)
    return callPost(`/authenticate.php`, bodyFormData, '', 1).then((res) => {
        return res?.data?.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const doChangePassword = async ({ newPassword, oldPassword, userId = null }) => {
    var token = JSON.parse(localStorage.getItem("token"));
    var bodyFormData = new FormData()
    bodyFormData.append('type', 'changePassword')
    bodyFormData.append('newPassword', newPassword)
    bodyFormData.append('oldPassword', oldPassword)
    bodyFormData.append('userId', userId)
    var apiPath = '/authenticate.php'
    if (userId) {
        apiPath = '/users.php'
    }
    return callPost(apiPath, bodyFormData, token).then((res) => {
        return res?.data?.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}

// auto log out user after 24 hours when token expires
export const autoLogOutTimer = (navigate) => {
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData && Object.values(userData).length > 0) {
        var token = JSON.parse(localStorage.getItem("token"));
        const decodedJwt = parseJwt(token);
        const expires = new Date(decodedJwt.exp * 1000);
        const timeout = expires.getTime() - Date.now();
        setTimeout(async () => {
            try {
                await doLogout(true)
            } catch {
                toast.show({
                    title: 'Warning',
                    description: 'Your session has been expired. Please login again.'
                })
                navigate('/')
            }
        }, timeout);
    }
}

const parseJwt = (token) => {
    try {
        return JSON.parse(window.atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
};

export const userLogs = async ({ userDetails }) => {
    var token = JSON.parse(localStorage.getItem("token"));
    var bodyFormData = new FormData()
    bodyFormData.append('type', 'userLogs')
    bodyFormData.append('userLogsDetails', JSON.stringify(userDetails))
    return callPost(`/userLogs.php`, bodyFormData, token).then((res) => {
        return res?.data?.data
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateUserTimezone = async (timezone) => {
    var token = JSON.parse(localStorage.getItem("token"));
    var bodyFormData = new FormData();
    bodyFormData.append('userData', JSON.stringify({ timezone }));
    bodyFormData.append('type', 'updateTimezone');

    persistUserTimezone(timezone)

    return callPost(`/users.php`, bodyFormData, token).then((res) => {
        const updatedUser = res?.data?.data?.data
        storeUserSession({ ...updatedUser, timezone: updatedUser?.timezone || timezone })
        return updatedUser
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateUserPersonalInfo = async (userData) => {
    var token = JSON.parse(localStorage.getItem("token"));
    var bodyFormData = new FormData();
    const resolvedUserId = userData?.id || parseJwt(token)?.id || null
    const resolvedUserData = {
        ...userData,
        id: resolvedUserId,
    }
    bodyFormData.append('userData', JSON.stringify(resolvedUserData));
    bodyFormData.append('type', 'update');

    return callPost(`/users.php`, bodyFormData, token).then((res) => {
        const updatedUser = res?.data?.data?.data
        storeUserSession(updatedUser)
        return updatedUser
    }).catch((err) => {
        return Promise.reject(err)
    })
}